import colors from './colors'
import { MOBILE, MOBILE_XS } from 'utils/constants'

const dialogStyles = {
  backgroundColor: colors.GoldenYellow50,
  borderRadius: 4,
  padding: 24,
  gap: 12,
  width: 550
}
const fullScreenDialog = {
  maxWidth: '100%',
  maxHeight: '100%',
  width: '100%',
  height: '100%',
  borderRadius: 0,
  margin: 0
}

const publicRolePlayStyles = {
  container: {
    maxWidth: '1380px',
    padding: '95px 112px',
    margin: '0 auto',
    '@media (max-width:1400px)': {
      padding: '95px 45px'
    },
    [MOBILE]: {
      padding: '48px 16px'
    }
  },
  stack: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    [MOBILE]: {
      flexDirection: 'column',
      alignItems: 'center'
    }
  },
  mobileOnly: {
    display: 'none',
    [MOBILE]: {
      display: 'block'
    }
  },
  head: {
    bannerStack: {
      gap: 84,
      flexDirection: 'row',
      justifyContent: 'space-between',
      '@media (max-width:1400px)': {
        gap: 12
      },
      [MOBILE]: {
        flexDirection: 'column-reverse',
        alignItems: 'center'
      }
    },
    h1: {
      color: colors.MidnightTeal400,
      fontFamily: 'P22Mackinac',
      fontSize: 50,
      fontWeight: 700,
      lineHeight: '126%',
      letterSpacing: '0.5px',
      [MOBILE]: {
        fontSize: 40,
        lineHeight: '125%',
        letterSpacing: '0.4px'
      }
    },
    typoStack: {
      gap: 24,
      flex: 2,
      [MOBILE]: {
        gap: 12,
        textAlign: 'center'
      }
    },
    bannerBtns: {
      gap: 4,
      justifyContent: 'flex-start',
      [MOBILE]: {
        gap: 8,
        '& .MuiButton-outlined': {
          padding: '16px 24px'
        }
      }
    },
    image: {
      width: 425,
      height: 425,
      flex: 1,
      [MOBILE]: {
        width: 250,
        height: 250
      }
    },
    expectContainer: {
      gap: 12,
      marginTop: -65,
      padding: '0 40px 40px',
      [MOBILE]: {
        gap: 8
      }
    }
  },
  scenario: {
    title: {
      color: colors.MidnightTeal400,
      textAlign: 'start',
      [MOBILE]: {
        textAlign: 'center'
      }
    },
    rolePlayCard: {
      padding: '40px 24px',
      [MOBILE]: {
        padding: '16px',
        maxWidth: '100%'
      }
    },
    interactionStack: {
      flexDirection: 'column',
      width: '100%',
      alignItems: 'center',
      gap: 8,
      [MOBILE]: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        gap: 4
      }
    },
    avatarBorder: {
      borderWidth: 3,
      borderStyle: 'solid',
      borderColor: colors.White
    },
    avatarSize: {
      width: 200,
      height: 200,
      [MOBILE]: {
        width: 76,
        height: 76
      },
      [MOBILE_XS]: {
        width: 60,
        height: 60
      }
    },
    botName: {
      [MOBILE]: {
        fontSize: 22
      },
      [MOBILE_XS]: {
        fontSize: 18
      }
    },
    actionStack: {
      gap: 8,
      alignItems: 'center',
      flex: 1,
      [MOBILE]: {
        gap: 4,
        alignItems: 'flex-end'
      }
    },
    interactionSelect: {
      padding: 5,
      width: 210,
      fontSize: 16,
      fontWeight: 600,
      color: colors.MidnightTeal400,
      [MOBILE]: {
        width: 210,
        padding: 1
      },
      [MOBILE_XS]: {
        width: 130,
        padding: 0,
        fontSize: 13
      }
    },
    actionButton: {
      [MOBILE]: {
        padding: '8px 16px'
      },
      [MOBILE_XS]: {
        padding: '4px 12px',
        fontSize: 13
      }
    },
    audioIcon: {
      backgroundColor: colors.White,
      '& .MuiBox-root': {
        padding: 8,
        height: 56,
        width: 56,
        [MOBILE]: {
          display: 'none'
        }
      }
    }
  },
  chatBox: {
    [MOBILE]: {
      position: 'fixed',
      right: 0,
      bottom: 0,
      top: 0,
      left: 0,
      background: colors.White,

      '& .MuiBox-root': {
        borderRadius: 0
      },
      '& #chat-head': {
        height: 80
      },
      '& #chat-foot': {
        height: 100,
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0
      },
      '& #chat-body': {
        height: 'calc(100vh - 180px)'
      }
    }
  },
  chatFooter: {
    padding: 8,
    borderRadius: '12px 12px 0 0',
    width: '100%',
    position: 'fixed',
    bottom: 0,
    left: 0,
    [MOBILE]: {
      display: 'block'
    }
  },
  callFooter: {
    [MOBILE]: {
      padding: '16px',
      maxWidth: '94%',
      position: 'fixed',
      bottom: '2%',
      left: '3%'
    }
  },
  result: {
    headStack: {
      paddingBottom: 16,
      gap: 12,
      [MOBILE]: {
        flexDirection: 'column-reverse',
        alignItems: 'center'
      }
    },
    heading: {
      color: colors.MidnightTeal400,
      fontFamily: 'P22Mackinac',
      fontSize: 40,
      fontWeight: 700,
      lineHeight: '130%',
      flex: 1,
      [MOBILE]: {
        fontSize: 32,
        lineHeight: '125%',
        textAlign: 'center'
      }
    },
    description: {
      color: colors.MidnightTeal400,
      fontSize: 18,
      fontWeight: 400,
      lineHeight: '130%',
      flex: 1
    },
    avatarBox: {
      display: 'flex',
      padding: 8,
      alignItems: 'flex-start',
      borderRadius: 81,
      borderStyle: 'solid',
      backgroundColor: colors.MidnightTeal400,
      height: '100%',
      position: 'relative',
      [MOBILE]: {
        padding: 3
      }
    },
    avatarArc: {
      width: 300,
      height: 300,
      border: `10px solid ${colors.Transparent}`,
      borderTop: `10px solid ${colors.GoldenYellow400}`,
      borderRadius: '50%',
      transform: 'rotate(45deg)',
      position: 'absolute',
      right: 11,
      top: 11,
      [MOBILE]: {
        width: 124,
        height: 124,
        borderWidth: 6,
        right: 3,
        top: 1
      }
    },
    avatarSize: {
      width: 300,
      height: 300,
      [MOBILE]: {
        width: 124,
        height: 124
      }
    },
    avatarText: {
      width: 'max-content',
      display: 'inline-flex',
      padding: '12px 16px;',
      alignItems: 'flex-start',
      gap: 4,
      borderRadius: '0px 20px 20px 20px',
      backgroundColor: colors.GoldenYellow50,
      boxShadow: `0px 0px 24px 0px ${colors.Grey400}`,
      position: 'absolute',
      bottom: '10%',
      left: 0,
      [MOBILE]: {
        padding: '6px 8px',
        bottom: 0,
        left: '-18%',
        '& .MuiTypography-root': {
          fontSize: 14
        }
      }
    },
    getResultPopup: {
      '& .MuiDialog-container': {
        alignItems: 'center',
        [MOBILE]: {
          alignItems: 'flex-start'
        }
      },
      '& .MuiPaper-root': {
        ...dialogStyles,
        flexDirection: 'column',
        alignItems: 'center',
        [MOBILE]: {
          width: '100%',
          padding: 10,
          gap: 8,
          margin: 5
        }
      }
    },
    resultFormDialog: {
      '& .MuiPaper-root': {
        ...dialogStyles,
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: 800,
        maxWidth: 800,
        gap: 32,
        [MOBILE]: {
          ...fullScreenDialog,
          padding: 10,
          gap: 12
        }
      }
    },
    resultFormStack: {
      gap: 12,
      [MOBILE]: {
        gap: 8
      }
    },
    backMobileBtn: {
      display: 'none',
      backgroundColor: colors.GoldenYellow100,
      '&:hover': {
        backgroundColor: colors.GoldenYellow100
      },
      [MOBILE]: {
        display: 'inline-flex'
      }
    },
    thanksDialog: {
      '& .MuiPaper-root': {
        ...dialogStyles,
        flexDirection: 'column',
        alignItems: 'center',
        [MOBILE]: {
          ...fullScreenDialog,
          padding: 10,
          gap: 12,
          justifyContent: 'center'
        }
      }
    },
    scenarioDialog: {
      '& .MuiPaper-root': {
        ...dialogStyles,
        width: '50%',
        gap: 0,
        [MOBILE]: {
          ...fullScreenDialog,
          padding: 10
        }
      }
    },
    feedbackDialog: {
      '& .MuiPaper-root': {
        ...dialogStyles,
        alignItems: 'center',
        width: 1000,
        [MOBILE]: {
          width: '100%',
          padding: 10,
          margin: 10
        }
      }
    },
    bookDemoWrapper: {
      display: 'flex',
      justifyContent: 'center',
      position: 'fixed',
      bottom: '3%',
      left: 0,
      right: 0,
      zIndex: 5
    },
    bookDemoBox: {
      display: 'inline-flex',
      padding: '16px 24px',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: 4,
      backgroundColor: colors.GoldenYellow50,
      boxShadow: `0px 0px 20px 0px ${colors.Grey400}`,
      gap: 4,
      [MOBILE]: {
        padding: '16px 20px'
      }
    },
    calendlyDialog: {
      '& .MuiPaper-root': {
        ...dialogStyles,
        width: '80%',
        maxWidth: '100%',
        height: '100%',
        [MOBILE]: {
          ...fullScreenDialog,
          padding: 10,
          paddingTop: 30
        }
      }
    }
  },
  footer: {
    container: {
      padding: '0 65px 0 175px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      height: 630,
      width: 'calc(100% + 150px)',
      marginLeft: '-75px',
      position: 'relative',
      overflow: 'hidden',
      borderRadius: 85,
      backgroundColor: colors.MidnightTeal400,
      [MOBILE]: {
        padding: '40px 16px 100px',
        borderRadius: 0,
        height: 'auto',
        width: '100%',
        marginLeft: 0
      }
    },
    circles: {
      maxWidth: '100%',
      maxHeight: '100%',
      position: 'absolute',
      bottom: 0,
      right: 0,
      zIndex: 0,
      [MOBILE]: {
        display: 'none'
      }
    },
    circlesImg: {
      position: 'relative',
      bottom: 0,
      right: '50%'
    },
    megaphoneBox: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: 430,
      height: 430,
      borderRadius: '430px',
      backgroundColor: colors.GoldenYellow50,
      position: 'relative',
      [MOBILE]: {
        width: 268,
        height: 268
      }
    },
    resultsImg: {
      width: 295,
      height: 160,
      position: 'absolute',
      bottom: 0,
      left: '-35%',
      [MOBILE]: {
        width: 225,
        height: 120,
        bottom: '-30%',
        left: '8%'
      }
    }
  }
}
export default publicRolePlayStyles
